import { ChakraFlex, ChakraText, EquipUITheme } from '@equip.health/ui';

import { MESSAGES_TITLE } from '~/lib/constants/chat.constants';
import ErrorMessagesFallback from './ErrorMessagesFallback';
import { FallbackProps } from 'react-error-boundary';

const { h5 } = EquipUITheme.typography;

const ErrorChannel = ({ resetErrorBoundary }: FallbackProps) => {
  return (
    <ChakraFlex
      alignItems="center"
      flexDirection="column"
      paddingTop="5px"
      width="350px"
    >
      <ChakraFlex alignItems="center" height="71px" width="100%">
        <ChakraText textAlign="left" width="100%" {...h5} marginBottom="10px">
          {MESSAGES_TITLE}
        </ChakraText>
      </ChakraFlex>

      <ErrorMessagesFallback resetErrorBoundary={resetErrorBoundary} />
    </ChakraFlex>
  );
};

export default ErrorChannel;
